<template>
  <ak-card v-if="service.inboundSettings.available">
    <ak-card-body class="block">
      <div><h3 class="color-grey">Inbound</h3></div>

      <!-- credentials unavailable -->
      <ak-empty-state
        v-if="!hasCredentials"
        icon="document-text"
        icon-size="gigantic"
      >
        <h3 class="color-grey">There are no credentials on file</h3>
        <p>
          Generate credentials to receive entity data from an external service.
        </p>
        <ak-button
          :disabled="service.working.value"
          @click="generateCredentials()"
          >Generate Credentials</ak-button
        >
      </ak-empty-state>

      <!-- credentials available -->
      <div v-else>
        <div><h4 class="color-grey">Settings</h4></div>
        <ak-integration-s-f-t-p-inbound-settings :service="service" />
        <ak-integration-s-f-t-p-operations :service="service" />
      </div>
    </ak-card-body>
  </ak-card>
</template>

<script>
import { computed, defineComponent } from 'vue'

import Button from '@akerolabs/akero-vue/src/components/button/Button.vue'
import Card from '@akerolabs/akero-vue/src/components/cards/Card.vue'
import CardBody from '@akerolabs/akero-vue/src/components/cards/CardBody.vue'
import EmptyState from '@akerolabs/akero-vue/src/components/emptyState/EmptyState.vue'
import IntegrationSFTPInboundSettings from './IntegrationSFTPInboundSettings.vue'
import IntegrationSFTPOperations from './IntegrationSFTPOperations.vue'

export default defineComponent({
  name: 'AkIntegrationSFTPInbound',
  components: {
    [Button.name]: Button,
    [Card.name]: Card,
    [CardBody.name]: CardBody,
    [EmptyState.name]: EmptyState,
    [IntegrationSFTPInboundSettings.name]: IntegrationSFTPInboundSettings,
    [IntegrationSFTPOperations.name]: IntegrationSFTPOperations,
  },
  provide() {
    return {
      akCards: undefined, // stub unneeded dependency
    }
  },
  props: {
    service: {
      required: true,
      type: Object,
    },
  },
  setup(props) {
    /**
     * Generate a set of inbound credentials
     * @returns {Promise<void>}
     */
    const generateCredentials = () =>
      props.service.handleInboundCredentialsGenerate()

    /**
     * Determine if the SFTP inbound integration has credentials
     * @returns {*}
     */
    const hasCredentials = computed(
      () =>
        !!props.service.inboundSettings.username &&
        props.service.inboundOperationsAndQuotasLoaded.value,
    )

    return {
      generateCredentials,
      hasCredentials,
    }
  },
})
</script>
